/* Dispatch estimates use a configurable US time zone and Monday–Friday processing. */
(function () {
  if (window.marlowUpdateShippingDates) {
    window.marlowUpdateShippingDates();
    return;
  }

  function shippingDate(now, timeZone, businessDays) {
    let parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', {
        timeZone, year: 'numeric', month: 'numeric', day: 'numeric'
      }).formatToParts(now);
    } catch (_) {
      parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric'
      }).formatToParts(now);
    }
    const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
    const date = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12));
    let remaining = Math.max(1, Math.min(7, Number(businessDays) || 3));
    while (remaining > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) remaining -= 1;
    }
    return {
      label: new Intl.DateTimeFormat('en-US', {
        timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric'
      }).format(date),
      iso: date.toISOString().slice(0, 10)
    };
  }

  window.marlowUpdateShippingDates = function () {
    document.querySelectorAll('.ev-shipping-strip').forEach((strip) => {
      const value = shippingDate(new Date(), strip.dataset.marlowShippingTimezone || 'America/New_York', strip.dataset.marlowProcessingDays);
      strip.querySelectorAll('[data-ev-ship-date]').forEach((node) => {
        node.textContent = value.label;
        node.setAttribute('datetime', value.iso);
      });
    });
  };
  document.addEventListener('shopify:section:load', window.marlowUpdateShippingDates);
  document.addEventListener('visibilitychange', window.marlowUpdateShippingDates);
  window.addEventListener('pageshow', window.marlowUpdateShippingDates);
  window.setInterval(window.marlowUpdateShippingDates, 60000);
  window.marlowUpdateShippingDates();
})();
